import { render, staticRenderFns } from "./MemorizingWords1Form.vue?vue&type=template&id=60c41af0&"
import script from "./MemorizingWords1Form.vue?vue&type=script&lang=js&"
export * from "./MemorizingWords1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports